import styled from 'styled-components';

export const Container = styled.div`
  .upload-area {
    border: 2px dashed #0d6efd;
    border-radius: 8px;
    background: #e9f2ff;
    height: 140px;
    cursor: pointer;
    transition: all 0.2s ease;
  }

  .upload-area:hover {
    background: #dfeaff;
  }

  .upload-icon {
    font-size: 22px;
    color: #0d6efd;
  }

  .upload-placeholder span {
    font-size: 16px;
  }

  .has-file {
    background: #f8f9fa;
    border-color: #28a745;
  }

  .upload-area.dragging {
    border-color: #007bff;
    background-color: #e8f0fe;
    opacity: 0.85;
  }
`;
